import currency from "currency.js";
import { useQuery } from "react-query";
import { Link, Outlet } from "react-router-dom";
import {
  FileListIcon,
  ArrowDownGrowthIcon,
  ArrowUpGrowthIcon,
  LineChartIcon,
  BucketIcon,
  PageHeaderListIcon,
  CurrencyFillIcon,
} from "../../components/Icons";
import { useAuth } from "../../hooks/useAuth";
import { useIsAdmin, useIsCashier, useIsSales } from "../../utils/hooks";
import "./../../assets/scss/invoicewrapper.scss";

export function BusinessDevelopmentCRMWrapper({ Nav }) {
  const { backendUrl } = useAuth();
  const isAdmin = useIsAdmin();
  const isCashier = useIsCashier();
  const isSales = useIsSales();

  const getStats = async () => {
    // await waitFor(5000);
    let response = await fetch(`${backendUrl}/api/items/stats`, {
      method: "GET",
      headers: {
        Accept: "Application/json",
        "Content-Type": "Application/json",
      },
      //  credentials: "include",
    });

    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }

    let { data } = await response.json();

    return data;
  };

  const { error, data, isSuccess, refetch, isFetching } = useQuery(
    ["ITEMS_STAT"],
    () => getStats(),
    {
      // enabled: false,
      // cacheTime: 0,
      onSuccess: (data) => {
        // queryClient.removeQueries("LOGIN");
      },
    }
  );

  return (
    <div className="invoice-wrapper ">
      <section className={`stats mb-3 ${isSales ? "two-column" : ""} `}>
        <div className="stat">
          <div className="icon bg-light-blue">
            <BucketIcon />
          </div>
          <div className="details">
            <p>
              {0}
            </p>
            <span>Total Customers</span>
          </div>
        </div>

        {!isSales ? (
          <>
            <div className="stat">
              <div className="icon bg-light-blue">
                <PageHeaderListIcon />
              </div>
              <div className="details">
                <p>
                  {0}
                </p>
                <span>Total Jobs</span>
              </div>
            </div>

            <div className="stat">
              <div className="icon bg-light-blue">
                <CurrencyFillIcon />
              </div>
              <div className="details">
                <p>
                  {0}
                </p>
                <span>Propective Customers</span>
              </div>
            </div>
          </>
        ) : null}

        <Link to="/supply-center" className="stat">
          <div className="icon bg-light-blue">
            <LineChartIcon />
          </div>
          <div className="details">
            <p>
              {0}
            </p>
            <span>Document & Certification</span>
          </div>
        </Link>
      </section>

      {Nav && <div className="nav-bar">{Nav}</div>}
      <Outlet />
    </div>
  );
}
